// extracted by mini-css-extract-plugin
module.exports = {"musicModal":"MusicModal_musicModal__3nxua","close":"MusicModal_close__3GBlp"};